import BaseService from "services/base";
import { builder } from "utils/graphql";
import { get } from "utils/lodash";
import { REVIEW_SELECTION, REVIEW_STATS_SELECTION } from "./constant";
class ReviewService extends BaseService {
  name = "Review";
  static override DEFINITION = builder.createDefinition({
    name: "Review",
    // quan trọng.
    baseQuery: "Review",
    baseSelection: `
        ${REVIEW_SELECTION}
    `,
    GQL_SHAPE_QUERY: {
      BASE: `
        {{ selections }}
      `,
      FIND: `
        docs {
          {{ selections }}
        }
      `,
      CREATE: `
        {{ selections }}
      `,
    },
    GQL_ACTIONS: {
      FIND: "Reviews",
      CREATE: "createReview",
      UPDATE: "updateReview",
      DELETE: "",
    },
    GQL_RESPONSE_DATA_PATH: {
      FIND: "data.Reviews.docs",
      PARAMS: "data.Reviews",
    },
  });
  findAuth(options: object = {}, selections: string = "") {
    const nameQuery = "authQueryReview";
    const inputType = "QueryReviewInput!";
    const customSelection = selections || REVIEW_SELECTION;

    return this.custom(
      {
        typeQL: "query",
        PATH_RESPONSE: {
          DATA: `data.${nameQuery}.reviews`,
          PARAMS: `data.${nameQuery}.queryParams`,
        },
        ...options,
      },
      `query ${nameQuery}($input: ${inputType}) {
        ${nameQuery} (input: $input) {
          reviews {
            ${customSelection}
          }
          queryParams {
            total
          }
        }
      }`
    );
  }
  getReviewStats(options: object = {}, selections: string = "") {
    const nameQuery = "publicGetReviewStats";
    const customSelection = selections || REVIEW_STATS_SELECTION;
    const shopId = get(options, "shopId");
    return this.custom(
      {
        typeQL: "query",
        PATH_RESPONSE: {
          DATA: `data.${nameQuery}`,
        },
        ...options,
      },
      `query ${nameQuery} {
        ${nameQuery} (shopId: "${shopId}") {
          ${customSelection}
        }
      }`
    );
  }
  queryUserReview(options: object = {}, selections: string = "") {
    const nameQuery = "queryUserReviews";
    const inputType = "QueryUserReviewsInput!";
    const customSelection = selections || REVIEW_SELECTION;
    return this.custom(
      {
        typeQL: "query",
        PATH_RESPONSE: {
          DATA: `data.${nameQuery}.reviews`,
          PARAMS: `data.${nameQuery}.queryParams`,
        },
        ...options,
      },
      `query ${nameQuery}($input: ${inputType}) {
        ${nameQuery} (input: $input) {
          reviews {
            ${customSelection}
          }
          queryParams {
            total
          }
        }
      }`
    );
  }
}
export * from "./constant";

const Instance = new ReviewService();

export default Instance;
